<template>
  <v-row v-if="pageType">
    <v-row v-if="floors && floors.length > 1">
      <v-col>
        <v-select
          v-model="tab"
          :items="floors"
          item-value="id"
          item-text="name"
          outlined
        ></v-select>
      </v-col>
    </v-row>

    <v-tabs v-model="viewType" grow fixed centered>
      <v-tab>
        <v-icon>mdi-google-maps</v-icon>
        &nbsp;{{ $t("view.mapView") }}
      </v-tab>
      <v-tab>
        <v-icon>mdi-view-list</v-icon>
        &nbsp;{{ $t("view.listView") }}
      </v-tab>

      <v-tab-item class="mt-3">
        <exhibition-view-map :floor="tab" />
      </v-tab-item>
      <v-tab-item class="mt-3">
        <exhibition-view-list :floor="tab" />
      </v-tab-item>
    </v-tabs>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ExhibitionViewMap from "./ExhibitionView/ExhibitionViewMap";
import ExhibitionViewList from "./ExhibitionView/ExhibitionViewList";

export default {
  components: {
    ExhibitionViewMap,
    ExhibitionViewList,
  },
  data() {
    return {
      tab: 0,
      viewType: 0,
      floors: [
        {
          id: 0,
          name: this.$i18n.t("form.floors.fullName.0"),
        },
        {
          id: 1,
          name: this.$i18n.t("form.floors.fullName.1"),
        },
        {
          id: 2,
          name: this.$i18n.t("form.floors.fullName.2"),
        },
      ],
    };
  },
  async created() {
    await this.getPageType();
    if (this.externalEventId) {
      this.floors = this.externalFloors.map((floor, index) => ({
        id: index,
        name: floor.name,
      }));
    }
    this.floors = this.sortFloors(this.floors);
  },
  methods: {
    ...mapActions(["getPageType"]),
    sortFloors(floors) {
      if (!Array.isArray(floors)) {
        return floors;
      }
      const isNumericStart = (s) => /^\s*\d/.test(String(s || ""));
      const leadingNumber = (s) => {
        const m = String(s || "").match(/\s*(\d+)/);
        return m ? parseInt(m[1], 10) : null;
      };
      return [...floors].sort((a, b) => {
        const nameA = a && a.name ? String(a.name) : "";
        const nameB = b && b.name ? String(b.name) : "";
        const aIsNum = isNumericStart(nameA);
        const bIsNum = isNumericStart(nameB);
        if (aIsNum && bIsNum) {
          const na = leadingNumber(nameA);
          const nb = leadingNumber(nameB);
          if (na != null && nb != null) {
            return na - nb;
          }
          return nameA.localeCompare(nameB);
        }
        if (aIsNum && !bIsNum) {
          return 1; // numeric-start should come after non-numeric
        }
        if (!aIsNum && bIsNum) {
          return -1;
        }
        return nameA.localeCompare(nameB);
      });
    },
    selectFloor(floor) {
      this.tab = floor;
    },
  },
  computed: {
    ...mapGetters(["pageType", "externalEventId", "externalFloors"]),
  },
};
</script>
